import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@/i18n';
import '@/assets/styles/variables.css';
import '@/assets/styles/global.css';

// ---- Recupero da chunk obsoleti dopo un deploy -----------------------------
// La SPA usa code-splitting con file hashati da Vite. Dopo un deploy i vecchi
// chunk spariscono dal server: una scheda rimasta aperta che prova a lazy-loadare
// una route (es. dettaglio articolo) riceve un 404 e Vite emette `vite:preloadError`.
// Ricarichiamo una sola volta per prendere l'index.html fresco (servito con
// Cache-Control: no-cache) e i chunk nuovi. Debounce anti-loop sui 10s.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'gsi:preload-reload-at';
  const last = Number(sessionStorage.getItem(KEY) ?? '0');
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  }
});

// ---- axe-core a11y audit (solo DEV) ----------------------------------------
// Fa side-effect run su ogni re-render: segnala violations WCAG nella console.
// In production non gira (zero overhead).
if (import.meta.env.DEV) {
  void import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000, {
      rules: [
        // Custom: ignoriamo le regole su contrasto AntD scure (gestite in dark mode).
      ],
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
